var R = "#ee0a24",
  O = "van-hairline",
  r = O + "--top",
  t = O + "--left",
  a = O + "--bottom",
  o = O + "--surround",
  T = O + "--top-bottom",
  B = O + "-unset--top-bottom";
export { O as BORDER, a as BORDER_BOTTOM, t as BORDER_LEFT, o as BORDER_SURROUND, r as BORDER_TOP, T as BORDER_TOP_BOTTOM, B as BORDER_UNSET_TOP_BOTTOM, R as RED };
